import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ServiceHero from './components/ServiceHero';
import ServiceShowcase from './components/ServiceShowcase';
import ProcessVisualization from './components/ProcessVisualization';
import TechnologyStack from './components/TechnologyStack';
import PricingCalculator from './components/PricingCalculator';
import ServiceTestimonials from './components/ServiceTestimonials';

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Services - Shutter Lifters | Custom Software Development & Design</title>
        <meta 
          name="description" 
          content="Explore our comprehensive software development services including custom software development, web applications, mobile solutions, and UI/UX design. Interactive demos and pricing calculator available." 
        />
        <meta name="keywords" content="software development, web applications, mobile apps, UI/UX design, custom software, technology consulting" />
        <meta property="og:title" content="Services - Shutter Lifters | Custom Software Development & Design" />
        <meta property="og:description" content="Transform your ideas into digital reality with our cutting-edge software development and design services." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/services" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          {/* Hero Section */}
          <ServiceHero />
          
          {/* Service Showcase with Interactive Demos */}
          <ServiceShowcase />
          
          {/* Development Process Visualization */}
          <ProcessVisualization />
          
          {/* Technology Stack Display */}
          <TechnologyStack />
          
          {/* Pricing Calculator */}
          <PricingCalculator />
          
          {/* Service-Specific Testimonials */}
          <ServiceTestimonials />
        </main>
      </div>
    </>
  );
};

export default ServicesPage;